export default __webpack_public_path__ + "static/media/relevant_certificates_and_audit_reports.655f03b3.svg";